import QuestionnaireFooter from 'app/features/questionnaires/components/QuestionnaireFooter';
import { ScrollContainer } from 'app/layout/dashboardLayout/BoxLayout';
import { InfoIcon } from 'assets/icons';
import { NavLink } from 'react-router-dom';

export interface IRetirementSocSecurityProps {}

export default function RetirementSocSecurity(
  props: IRetirementSocSecurityProps,
) {
  return (
    <>
      <ScrollContainer className="p-4">
        <div className="flex max-w-min gap-2 items-center font-semibold text-sm bg-green-light text-green rounded-lg px-4 py-1 ">
          <InfoIcon />
          Information
        </div>
        <div className="flex mt-2 md:text-sm text-gray-dark font-medium text-base mb-1 capitalize md-max:col-span-4 md-max:flex md-max:flex-wrap">
          Please provide information in &nbsp;
          <NavLink to="../../income/otherIncome">
            <span className="flex items-center text-green font-semibold">
              Other Income
            </span>
          </NavLink>
          &nbsp;(this link is clickable)
        </div>
      </ScrollContainer>

      <QuestionnaireFooter />
    </>
  );
}
